<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.character" placeholder="请选择" size="small">
                        <el-option label="不限制申请性质" :value="0"></el-option>
                        <el-option label="仅看初次提交的" :value="1"></el-option>
                        <el-option label="仅看二次提交的" :value="2"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.source" placeholder="不限制创建来源" class="fl fl-big-select" clearable size="small">
						<el-option label="不限制创建来源" value=""></el-option>						
				        <el-option v-for="(item, index) in activityChannel" :label="item.value" :key="index" :value="item.key"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制审核状态" :value="0"></el-option>
                        <el-option label="仅看待审核的" :value="1"></el-option>
                        <el-option label="仅看已拒绝的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sendStatus" placeholder="请选择" size="small">
                        <el-option label="不限制寄送状态" :value="0"></el-option>
                        <el-option label="仅看待发出的" :value="1"></el-option>
                        <el-option label="仅看已发出的" :value="2"></el-option>
                        <el-option label="仅看已寄回的" :value="3"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="14" :lg="12" :xl="8" >
					<div class="clearfix timeType">
					    <el-input class="input-with-select fl" size="small">
					        <el-select v-model="queryTimeKey" slot="prepend" placeholder="请选择">
					            <el-option label="申请提交时间" :value="1"></el-option>
					        </el-select>
					    </el-input>
					    <el-date-picker
					        v-model="datetimerange"
					        type="datetimerange"
					        start-placeholder="开始时间"
					        end-placeholder="结束时间"
					        class="fl"
					        size="small"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        :default-time="['00:00:00', '23:59:59']"
					        unlink-panels
					        >
					    </el-date-picker>
					</div>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
		<div class="page-btns-box">		   
		    <el-button v-if="$utils.have('/activity/receivables/audit/export')" type="primary" icon="el-icon-download" size="small" @click="download()" :loading="downLoading">导出审核列表</el-button>
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="source" label="创建来源"></el-table-column>
				<el-table-column prop="character" label="申请性质">
                    <template slot-scope="scope">
                        <span v-if="scope.row.character == 1">初次提交</span>
                        <span v-else>二次提交</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="审核状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">待审核</span>
                        <span v-else-if="scope.row.status == 3">已拒绝</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sendStatus" label="寄送状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sendStatus == 1">待发出</span>
                        <span v-else-if="scope.row.sendStatus == 2">已发出</span>
                        <span v-else-if="scope.row.sendStatus == 3">已寄回</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userType" label="用户身份">
                    <template slot-scope="scope">
                        {{$userType.get(scope.row.userType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="name" label="用户名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="申请提交时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="70">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activity/receivables/getDetailInfo')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row.id,scope.row.character)"
                            >管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo:1,
    queryType: 1,
    queryValue: '',
    character: 0,
    status: 1,
    sendStatus: 0,
	beginTime:'',
	endTime:'',
	source:''
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                queryType: parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || '',
                character: parseInt(this.$route.query.character || 0),
                status: parseInt(this.$route.query.status || 1),
                sendStatus: parseInt(this.$route.query.sendStatus || 0),
            },
			queryTimeKey:1,
			datetimerange:[this.$route.query.beginTime || '' , this.$route.query.endTime || ''],
            listLoading: true,
			activityChannel:[],
			downLoading:false
        }
    },
    mounted() {
        this.getDataList();
		this.getChannel()
    },
    methods:{
		//获取演出渠道
		getChannel() {
			this.$request({
				url: "/common/activitySource",
				method: "post",
				
			}).then(res => {
				const { state, result } = res.data;
				if (state == 1 && result) {
					var _result = result;					
					_result.forEach((tab, idx) => {
						let obj = {
							key: tab.key,
							value:tab.value == '秀动自营' ? '经营平台' : tab.value
						}
						this.activityChannel.push(obj)					   
					})					
				}
			})
		},
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/receivables/getPageList",
                method: "POST",
                data: {
                    ...this.params,
					beginTime:this.datetimerange && this.datetimerange[0] || '',
					endTime:this.datetimerange && this.datetimerange[1] || ''
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
			this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //详情事件
        view(id,character){
            this.$router.push({
                path: `/finance/activity/receivables/audit/${id}`,
                query: {
                    character: character,
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
		async download(){
		    let filePath;
		    this.downLoading = true;
		    const res = await this.$request({
		        url:'/activity/receivables/audit/export',
		        method: 'post',
		        data: {
		            ...this.params,
		        	beginTime:this.datetimerange && this.datetimerange[0] || '',
		        	endTime:this.datetimerange && this.datetimerange[1] || ''
		        },
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result} = res.data;
		    if(state == 1 && result){
		        filePath = result.url;
		    }else{
		        this.downLoading = false;
		        return this.$message.error(msg || '下载失败');
		    }   
		
		    await downloadFileTmp(filePath,'演出收款信息审核列表.'+this.$utils.getFileType(filePath));
		    this.downLoading = false;
		},
    }
}
</script>